/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `NOT_OWNED_BY_COMPANY` - Not Owned By Company
 * * `OWNED_BUT_NO_SITE` - Owned But No Site
 * * `OWNED_AND_LINK_TO_SITE` - Owned And Link To Site
 * @export
 */
export const DecisionEnum = {
    NotOwnedByCompany: 'NOT_OWNED_BY_COMPANY',
    OwnedButNoSite: 'OWNED_BUT_NO_SITE',
    OwnedAndLinkToSite: 'OWNED_AND_LINK_TO_SITE'
} as const;
export type DecisionEnum = typeof DecisionEnum[keyof typeof DecisionEnum];


export function instanceOfDecisionEnum(value: any): boolean {
    for (const key in DecisionEnum) {
        if (Object.prototype.hasOwnProperty.call(DecisionEnum, key)) {
            if (DecisionEnum[key as keyof typeof DecisionEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DecisionEnumFromJSON(json: any): DecisionEnum {
    return DecisionEnumFromJSONTyped(json, false);
}

export function DecisionEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DecisionEnum {
    return json as DecisionEnum;
}

export function DecisionEnumToJSON(value?: DecisionEnum | null): any {
    return value as any;
}

export function DecisionEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DecisionEnum {
    return value as DecisionEnum;
}

